import { fetchApi } from '@/helpers/fetchApi.js'

export default {
  state: {
    post_categories: [],
    post_categories_loading: false,
  },
  getters: {
    post_category: (state) => (id) =>
      state.post_categories.find((category) => category.id.toString() === id.toString()),
    post_categories: (state) => state.post_categories,
  },
  mutations: {
    setPostCategories(state, post_categories) {
      state.post_categories = post_categories
    },
    setPostCategoriesLoading(state, value) {
      state.post_categories_loading = value
    },
  },
  actions: {
    async fetchPostCategories({ state, commit }) {
      if (state.post_categories_loading) return

      commit('setPostCategoriesLoading', true)

      try {
        const post_categories = await fetchApi('post-categories')

        commit('setPostCategories', post_categories)
      } finally {
        commit('setPostCategoriesLoading', false)
      }
    },
    async loadPostCategories({ state, dispatch }) {
      if (!state.post_categories.length) {
        await dispatch('fetchPostCategories')
      }
    },
    async emptyPostCategories({ commit }) {
      commit('setPostCategories', [])
    },
  },
}
